import { render, staticRenderFns } from "./DocModal.vue?vue&type=template&id=aa828806&scoped=true"
import script from "./DocModal.vue?vue&type=script&lang=ts"
export * from "./DocModal.vue?vue&type=script&lang=ts"
import style0 from "./DocModal.vue?vue&type=style&index=0&id=aa828806&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa828806",
  null
  
)

export default component.exports